import React from 'react';

interface HandshakeIconProps {
  className?: string;
}

function HandshakeIcon({ className }: HandshakeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="18"
      fill="none"
      viewBox="0 0 27 18"
      className={className}
    >
      <path
        fill="currentColor"
        d="M9.58 1.741l-.32.157c-.396.193-.862.22-1.274.073l-.533-.188a.396.396 0 00-.095-.047L4.076.612a.475.475 0 00-.6.293L.72 8.927a.478.478 0 00.021.36c.052.11.152.2.272.241l3.277 1.124a.478.478 0 00.601-.293l2.597-7.557.178.063c.653.23 1.385.188 2.012-.115l.319-.157a1.66 1.66 0 011.264-.078l6.026 2.074c-.062.251-.188.55-.418.711-.256.178-.637.178-1.14.005l-2.685-.92a.472.472 0 00-.612.33c-.005.015-.376 1.406-1.563 2.043-.747.403-1.677.418-2.77.047a.475.475 0 00-.6.293.475.475 0 00.292.601c.627.214 1.218.324 1.767.324.637 0 1.223-.141 1.756-.429 1.06-.57 1.61-1.567 1.86-2.163l2.242.768c.8.277 1.469.235 1.986-.125.831-.575.873-1.74.878-1.793a.474.474 0 00-.319-.46l-6.396-2.205a2.645 2.645 0 00-1.986.125zm-5.425 7.86l-2.383-.815 2.44-7.123 2.383.815-2.44 7.123z"
      ></path>
      <path
        fill="currentColor"
        d="M22.134 10.139l-1.124 1.035a14.356 14.356 0 01-3.413 2.33l-5.963 2.917a.53.53 0 01-.71-.246.53.53 0 01.245-.71l.073-.037 3.261-1.594a.473.473 0 10-.412-.852l-3.262 1.594-1.64.805a.53.53 0 01-.712-.246.527.527 0 01.24-.705l1.24-.607 3.543-1.735a.473.473 0 10-.413-.852l-3.549 1.74-.135.068-1.694.832a.527.527 0 01-.706-.24.53.53 0 01.246-.712l.586-.287 1.196-.585.335-.162 2.749-1.349a.473.473 0 10-.413-.852l-2.979 1.458-1.301.638a.534.534 0 01-.737-.648.527.527 0 01.266-.303L9.225 9.72a.473.473 0 10-.413-.852L6.539 9.982a1.456 1.456 0 00-.748.847c-.125.37-.104.773.068 1.128.11.22.267.403.455.539a1.483 1.483 0 00-.157 1.552 1.456 1.456 0 001.317.826 1.48 1.48 0 002.127 1.359l.335-.163c.015.178.062.35.14.518a1.48 1.48 0 001.976.674l5.963-2.916a15.298 15.298 0 003.638-2.483l1.332-1.228 3.053-1.495a.473.473 0 00.22-.632L22.525.904a.473.473 0 00-.633-.22l-3.115 1.521a.473.473 0 00-.22.633l3.576 7.3zm-.251-8.394l3.308 6.768-2.263 1.108-3.308-6.768 2.263-1.108z"
      ></path>
    </svg>
  );
}

export default HandshakeIcon;
